import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
//components
import Verification from '../../components/signin/Verification'
// images
import Logo from '../../assets/image/logo/ic-logo-ho.svg'
// images
import SelectImg from '../../assets/image/radio/ic-select.png'
import UnSelectImg from '../../assets/image/radio/ic-unselect.png'
// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'
// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'

export default function FindId() {
  const [selectedIndex, setSelectedIndex] = useState()

  const [name, setName] = useState('')
  const [phoneNum, setPhoneNum] = useState('')
  const [minutes, setMinutes] = useState(undefined)
  const [seconds, setSeconds] = useState(undefined)
  const [clientMsg, setClientMsg] = useState('')
  const [isVerification, setIsVerification] = useState(false)
  const [showIdResult, setShowIdResult] = useState(false)
  const [idResults, setIdResults] = useState([])
  const [selectedResultId, setSelectedResultId] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [certificationId, setCertificationId] = useState()
  const navigate = useNavigate()
  const isLeftAlign = false
  const { fetchData, loading, data, error } = useAxios()

  const leftText = '아이디 찾기'
  const rightText = '비밀번호 초기화'

  const selectResultId = (idx, id) => {
    setSelectedIndex(idx)
    setSelectedResultId(id)
  }

  // 입력값 체크
  const requestVerification = (e) => {
    // e.preventDefault()
    if (name == '') {
      setClientMsg('이름을 입력해주세요.')
      return false
    }

    if (phoneNum == '') {
      setClientMsg('휴대전화번호를 입력해주세요.')
      return false
    }

    const requestBody = {
      userName: name,
      userMobile: phoneNum,
    }
    const params = {}

    // 로그인 아이디 찾기 인증번호 발송
    fetchData(
      constants.API.FIND_ID_CERTIFICATION, // url
      'POST', // method
      requestBody, // data
      params,
    )
  }

  // Verification 인증번호 result처리
  const handleVerificationResponse = (response, error) => {
    if (response) {
      const resultCode = response.responseCode
      const userIdList = response.responseData?.userIdList

      if (resultCode == TYPE.API_RESPONSE.SUCCESS && userIdList) {
        setIdResults(userIdList)
        setShowIdResult(true)
      }
    }
  }

  // 인증번호 발송 result
  useEffect(() => {
    if (data) {
      switch (data.responseCode) {
        case TYPE.API_RESPONSE.SUCCESS:
          alert(
            '인증번호를 발송했습니다. \n 인증번호가 오지 않으면 입력하신 정보가 \n 회원정보와 일치하는지 확인해 주세요.',
          )
          setCertificationId(data.responseData.certificationId)
          if (data.responseData.certificationCode) {
            setVerificationCode(data.responseData.certificationCode)
          }
          setIsVerification(true)
          setClientMsg('')
          setMinutes(5)
          setSeconds(0)
          break

        case TYPE.API_RESPONSE.MEMBER_9992: // 계정을 찾을 수 없습니다.
          setClientMsg('계정을 찾을 수 없습니다.')
          break

        case TYPE.API_RESPONSE.MEMBER_9999: // 실패
          setClientMsg('실패')
          break

        default:
          break
      }
    }
  }, [data])

  return (
    <Container>
      <Wrapper>
        <ContentWrapper>
          <LogoImg
            src={Logo}
            className=""
            onClick={() => navigate('/signin')}
          />
          <TitleTextWrapper>
            <TitleText>해피오더 사장님</TitleText>
          </TitleTextWrapper>
          <TabContainer isLeftAlign={isLeftAlign}>
            <SelectWrapper>
              <AllAnswerWrapper isActive="0">{leftText}</AllAnswerWrapper>
              <DivideLine />
              <UnAnswerWrapper onClick={() => navigate('/changePassword')}>
                {rightText}
              </UnAnswerWrapper>
            </SelectWrapper>
          </TabContainer>
          {showIdResult ? (
            <>
              <IdListWrapper>
                {idResults.map((result, idx) => (
                  <div className="pb-4" key={idx}>
                    <div className="form-check-inline-block d-flex align-items-center mt-3">
                      <RadioCircle
                        src={selectedIndex === idx ? SelectImg : UnSelectImg}
                        onClick={() => selectResultId(idx, result.loginId)}
                      />
                      <label className="form-check-label ms-2">
                        <span className="d-block text-start">
                          <IdTitleText>{result.loginId}</IdTitleText>
                        </span>
                      </label>
                    </div>
                    <DateRangeTextWrapper>
                      <DateRangeText>
                        매장: {result.brandName + ' ' + result.storeName}
                      </DateRangeText>
                    </DateRangeTextWrapper>
                  </div>
                ))}
              </IdListWrapper>
              <IdResultMsg>
                입력하신 정보와
                <br /> 일치하는 아이디입니다.
              </IdResultMsg>
              <BttnWrapper>
                <Button
                  onClick={() =>
                    navigate('/signin', {
                      replace: true,
                      state: {
                        selectedUserId: selectedResultId,
                      },
                    })
                  }
                >
                  홈으로 가기
                </Button>
                <Button
                  onClick={() =>
                    navigate('/changePassword', {
                      replace: true,
                      state: {
                        selectedUserId: selectedResultId,
                      },
                    })
                  }
                >
                  비밀번호 초기화
                </Button>
              </BttnWrapper>
            </>
          ) : (
            <>
              <Input
                type="text"
                placeholder="이름"
                value={name}
                onChange={(e) => {
                  const newValue = e.target.value.replace(
                    /[\d!@#$%^&*()_+]/g,
                    '',
                  )
                  setName(newValue)
                }}
              />
              <PhoneWrapper>
                <Input
                  type="tel"
                  placeholder='휴대전화번호 ("-"는 제외하고 숫자만 입력하세요)'
                  value={phoneNum}
                  onChange={(e) => {
                    const newValue = e.target.value.replace(/[^0-9]/g, '')
                    setPhoneNum(newValue)
                  }}
                />
              </PhoneWrapper>
              {/* <RulesTxt></RulesTxt> */}
              <ClientMsgWrapper>{clientMsg}</ClientMsgWrapper>
              {isVerification ? (
                <VerificationWrapper>
                  <Verification
                    minutes={minutes}
                    seconds={seconds}
                    setSeconds={setSeconds}
                    setMinutes={setMinutes}
                    onResponse={handleVerificationResponse}
                    findId={true}
                    name={name}
                    phoneNum={phoneNum}
                    requestVerificationFindId={requestVerification}
                    certificationId={certificationId}
                    setCertificationId={setCertificationId}
                    verificationCode={verificationCode}
                    setVerificationCode={setVerificationCode}
                  />
                </VerificationWrapper>
              ) : (
                <BtnWrap>
                  <CancleButton
                    type="button"
                    onClick={() => navigate('/signin')}
                  >
                    취소
                  </CancleButton>
                  <ResendVerfButton
                    type="button"
                    onClick={(e) => requestVerification(e)}
                  >
                    인증번호 요청
                  </ResendVerfButton>
                </BtnWrap>
              )}
            </>
          )}
          <TradeMarkWrapper>
            <TradeMarkText>
              Copyright ⓒ by SPC ALL RIGHTS RESERVED.
            </TradeMarkText>
          </TradeMarkWrapper>
        </ContentWrapper>
      </Wrapper>
    </Container>
  )
}
const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    display: none;
  }
`
const IdResultMsg = styled.div`
  margin: 53px 73px 50px;
  font-family: NotoSansKR;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #000;
  @media ${(props) => props.theme.mobile} {
    margin: 45px 43px;
  }
`
const RadioCircle = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`
const IdTitleText = styled.span`
  width: 32px;
  height: 17px;
  font-family: NotoSansKR;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: ${colors.BK};
`
const DateRangeText = styled.span`
  width: 264px;
  height: 17px;
  font-size: 14px;
  text-align: left;
  color: ${colors.G4};
`

const DateRangeTextWrapper = styled.div`
  margin-left: 2rem;
  float: left;
`

const IdListWrapper = styled.div`
  width: 100%;
  height: 203px;
  /* margin: 38px 0px 53px 0px; */
  padding: 0px 15px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  overflow-y: auto;
`
const ClientMsgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  text-align: left;
  color: #d90000;
  padding: 15px 0px;
  @media ${(props) => props.theme.tablet} {
    padding: 15px 0px;
  }
`
const Wrapper = styled.div`
  width: 430px;
  height: 813px;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(102, 102, 102, 0.1);
  background-color: #fff;
  padding: 50px 30px 30px;
  display: flex;
  justify-content: center;
  color: #8a8a8a;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
    width: 360px;
    height: 760px;
    padding: 50px 30px 20px 30px;
    box-shadow: none;
  }
`
const LogoImg = styled.img`
  width: 129.3px;
  height: 50px;
  cursor: pointer;
`
const VerificationWrapper = styled.div`
  padding-top: 60px;
  @media ${(props) => props.theme.mobile} {
    padding-top: 20px;
  }
`
const TitleTextWrapper = styled.div`
  margin: 15px 0px 25px;
  @media ${(props) => props.theme.mobile} {
  }
`
const TitleText = styled.span`
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: #00402e;
  @media ${(props) => props.theme.mobile} {
  }
`
const RulesTxt = styled.div`
  font-size: 14px;
  text-align: left;
  color: #8a8a8a;
  width: 360px;
  margin: auto;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const Input = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 360px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 10px;
  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const PhoneInput = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 259px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 10px;

  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 204px;
  }
`
const PhoneWrapper = styled.div`
  display: flex;
  width: 360px;
  margin: auto;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    margin: auto;
  }
`
const PhoneNumber = styled.div`
  display: inline;
  &:focus {
    outline: none !important;
    border: none !important;
  }
`

const AreaCode = styled.div`
  display: inline;
  margin-right: 10px;
  .form-select {
    width: 91px;
    height: 50px;
    padding: 15px 13px 15px 20px;
    border-radius: 8px;
    border: solid 1px #e5e5e5;
    background-color: #fff;
    font-size: 14px;
    text-align: left;
    color: #a8a8a8;
    outline: none !important;
  }

  .form-control:focus {
    outline: none !important;
    border: none !important;
  }
  select:focus {
    outline: none !important;
    border: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    .form-select {
      width: 88px;
    }
  }
`
const BttnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-around;
  /* position: absolute; */
  /* bottom: 10%; */
  gap: 10px;
  width: 100%;
  @media ${(props) => props.theme.mobile} {
  }
`
const Button = styled.div`
  /* position: absolute; */
  bottom: 10%;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const BtnWrap = styled.div`
  position: absolute;
  bottom: 10%;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`
const ResendVerfButton = styled.button`
  width: 100%;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  border: none;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const CancleButton = styled.button`
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #000;
  border: solid 1px #e5e5e5;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`

const TradeMarkWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
  }
`
const TradeMarkText = styled.span`
  font-size: 12px;
  color: #a8a8a8;
  @media ${(props) => props.theme.mobile} {
  }
`
const TabContainer = styled.div`
  width: ${(props) => props.isLeftAlign && '100%'};
  display: flex;
  flex-direction: row;
  margin: 50px 0px 35px;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    margin: 50px 0px 35px;
  }
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  cursor: pointer;
`

const AllAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  background-color: #fff;
  background-color: ${colors.mainG};
  font-weight: bold;
  font-size: 16px;
  color: ${colors.W1};
  &:hover {
    color: ${colors.W1};
    border-left: 1px solid ${colors.mainG};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const DivideLine = styled.div`
  width: 1px;
  background-color: ${colors.mainG};
`

const UnAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  color: #a8a8a8;
  &:hover {
    color: ${colors.W1};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    border-right: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
